import { useEffect, useSyncExternalStore } from 'react'
import { checkboxStore } from './checkbox-store'

export function useRegisterCheckbox(id: string, keepRegisteredOnDispose: boolean = false) {
  useEffect(() => {
    checkboxStore.register(id)

    return () => {
      if (!keepRegisteredOnDispose) checkboxStore.unregister(id)
    }
  }, [id]) // eslint-disable-line react-hooks/exhaustive-deps
}

export function useCheckbox(id: string) {
  return useSyncExternalStore(
    (listener) => checkboxStore.subscribeCheckbox(id, listener),
    () => checkboxStore.isChecked(id),
  )
}

export function useAllChecked() {
  return useSyncExternalStore(checkboxStore.subscribeAll, () => checkboxStore.areAllChecked())
}

export function useCheckboxActions() {
  return {
    setChecked: checkboxStore.setChecked.bind(checkboxStore),
    toggle: checkboxStore.toggle.bind(checkboxStore),
    setAll: checkboxStore.setAll.bind(checkboxStore),
    // reset: checkboxStore.reset.bind(checkboxStore), по идее - не понадобится
  }
}

export function useIndeterminate() {
  return useSyncExternalStore(checkboxStore.subscribeAll, () => checkboxStore.isIndeterminate())
}

export function useCheckedCount() {
  return useSyncExternalStore(checkboxStore.subscribeAll, () => checkboxStore.getCheckedCount())
}

export function useCheckedIds() {
  return useSyncExternalStore(checkboxStore.subscribeAll, () => checkboxStore.getCheckedIds())
}
